<section class="row mr-5 ml-5 mt-5 mb-3">
  <form [formGroup]="formCodigoConducta" (ngSubmit)="goPaso()">
    <app-ayudas [ayuda]="ayudaService.codigoConducta(
        datoSolicitudSharedModel.tipo_solicitud, 
        datoSolicitudSharedModel.tipo_rnt, 
        rnt.sub_categoria_id,
        rnt.estado_rnt_id,
        rnt.estado_solicitud_id
         )"></app-ayudas>
    <header>
      <h2 class="h4">Código de Conducta (Ley 1336 de 2009)</h2>
      <label class="text-muted">Por favor lea todo el texto y de click en "He leído y acepto el código de conducta"</label>
    </header>
    <section class="conducta">
      <p [innerHTML]="codigoConducta.titulo"></p>
      <p class="text-muted text-justify" [innerHTML]="codigoConducta.descripcion">
      </p>
      <div class="form-group text-right">
        <label class="form-check-label mr-4">He leído y acepto el código de conducta</label>
        <input formControlName="acepta_codigo_conducta" type="checkbox" class="form-check-inline" />
      </div>
    </section>
    <footer class="text-right p-3">
      <button type="button" class="btn btn-outline-primary paso-capacidad-info-btn-inicio mr-2 pl-4 pr-4" (click)="onRegresarPaso()">{{boton_atras}}</button>
      <button class="btn btn-primary paso-codigo-conducta-btn-inicio" [disabled]="!formCodigoConducta.valid">{{boton}}</button>
    </footer>
  </form>
</section>
